module.exports = __webpack_public_path__ + "static/media/3 knee ex.d2b180eb.png";